<template>
  <div>
    <div class="tw-flex tw-justify-between tw-items-center tw-gap-2 tw-mb-8">
      <h1>{{ $t('adm.agency.users.title') }}</h1>
      <div class="tw-flex tw-gap-6">
        <DebouncedSearch
          :query="searchQuery"
          :search="search"
          :placeholder="$t('common.actions.search')"
        />
        <i-button
          type="primary"
          size="medium"
          @click="isAddUserDialogOpen = true"
        >
          <icon-plus class="tw-mr-2" />
          {{ $t('adm.agency.users.create_button') }}
        </i-button>
      </div>
    </div>

    <div v-loading="isLoading">
      <AgencyUsersFilters class="tw-mb-8" />

      <div
        class="tw-overflow-auto"
      >
        <AdministrationTableList
          store-path="v2/admin/cms/agency/users"
          list-relative-path="users"
          list-item-component-name="AgencyUsersListItem"
          list-item-prop-name="user"
          :columns="columns"
        />
      </div>
      <AdministrationTablePagination
        store-path="v2/admin/cms/agency/users"
        filter-relative-path="filters"
      />
    </div>

    <AddAgencyUserDialog
      :is-open="isAddUserDialogOpen"
      @close="isAddUserDialogOpen = false"
      @refresh="load"
    />
    <ForeignersMessagingPopover />
  </div>
</template>

<script>
import ForeignersMessagingPopover from '@/components/Foreigners/Messaging/ForeignersMessagingPopover.vue';
import AdministrationTablePagination from '@/components/Administration/components/AdministrationTablePagination.vue';
import AdministrationTableList from '@/components/Administration/components/AdministrationTableList.vue';
import AgencyUsersFilters from '@/components/Administration/Agency/Users/AgencyUsersFilters.vue';
import { usersTableColumns } from '@/components/Administration/Agency/Users/constants';
import AddAgencyUserDialog from '@/components/Administration/Agency/Users/AddAgencyUserDialog.vue';
import DebouncedSearch from '@/components/shared/DebouncedSearch.vue';
import { mapState } from 'vuex';

export default {
  name: 'AgencyUsersV2',
  components: {
    DebouncedSearch,
    AddAgencyUserDialog,
    AgencyUsersFilters,
    AdministrationTablePagination,
    AdministrationTableList,
    ForeignersMessagingPopover,
  },
  data() {
    return {
      isAddUserDialogOpen: false,
      searchQuery: '',
    };
  },
  computed: {
    ...mapState({
      filters: (state) => state.v2.admin.cms.agency.users.filters,
      users: (state) => state.v2.admin.cms.agency.users.users,
      isLoading: (state) => state.v2.admin.cms.agency.users.isLoading,
    }),
    columns() {
      return usersTableColumns;
    },
  },
  watch: {
    filters: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },
  mounted() {
    this.load();
    this.$store.dispatch('v2/admin/cms/agency/companies/loadAllCompanies');
    this.$store.dispatch('v2/shared/enums/loadAgencyUserRoles');
    this.searchQuery = this.filters.search;
  },
  methods: {
    load() {
      this.$store.dispatch('v2/admin/cms/agency/users/load');
    },
    search(query) {
      this.$store.commit('v2/admin/cms/agency/users/updateFilter', { field: 'search', payload: query });
    },
  },
};
</script>
